"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ResponsiveModal = _interopRequireDefault(require("../../ResponsiveModal"));
var _Feedback = _interopRequireDefault(require("../../Feedback"));
var WriteUsPopup = function WriteUsPopup(_ref) {
  var showPopup = _ref.showPopup,
    onCloseModal = _ref.onCloseModal,
    isMobile = _ref.isMobile;
  var popupStyles = {
    modal: {
      width: '100%',
      height: "".concat(isMobile ? '100%' : '')
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_ResponsiveModal["default"], {
    open: showPopup,
    styles: popupStyles,
    onClose: onCloseModal
  }, /*#__PURE__*/_react["default"].createElement(_Feedback["default"], {
    isMobile: isMobile
  }));
};
var _default = exports["default"] = WriteUsPopup;